import { PaperIcon } from '@nackle/paper';
import React, { useMemo } from 'react';




const StatusIcon = ( { status } ) => {

    const icon = useMemo( () => {
        return status == 'IN_PROGRESS' ? 
                <PaperIcon key='progress-icon' icon='Hourglass' collection='antd-outlined' className='progress secondary' /> :
            status == 'COMPLETED' ?
                <PaperIcon key='completed-icon' icon='CheckCircle' collection='antd-outlined' className='progress completed primary success' /> :
                <></>;
    }, [ status ] );

    return icon;

};


export default StatusIcon;